//Activity
export const START_GET_ACTIVITY_LOG = "START_GET_ACTIVITY_LOG";
export const SUCCESS_GET_ACTIVITY_LOG = "SUCCESS_GET_ACTIVITY_LOG";
export const ERROR_GET_ACTIVITY_LOG = "ERROR_GET_ACTIVITY_LOG";

export const START_GET_FIELD_STAFF_LIST = "START_GET_FIELD_STAFF_LIST";
export const SUCCESS_GET_FIELD_STAFF_LIST = "SUCCESS_GET_FIELD_STAFF_LIST";
export const ERROR_GET_FIELD_STAFF_LIST = "ERROR_GET_FIELD_STAFF_LIST";

export const RESET_ACTIVITY_STATE = "RESET_ACTIVITY_STATE";
